import { lazy } from 'react';

import { MenuItemConfig, ReactPageConfig } from '@intelliarts/ia-react-template';

import authConfig, { HR_MENU_GROUP } from '../../../config/authConfig';
import { EmploymentsStore } from '../../Employee/store/employmentsStore';
import { ChangeReasonsStore } from '../../Employee/store/changeReasonsStore';
import { OFFBOARDING_PAGE_LOCALE_PATH } from '../../Employee/locales';

export const OffboardingRoutes = {
  default: 'offboarding',
};

export const OffboardingPageConfig: ReactPageConfig = {
  name: `${OFFBOARDING_PAGE_LOCALE_PATH}.pageConfig.name`,
  path: OffboardingRoutes.default,
  allowedRoles: [ authConfig.roles.ADMIN ],
  component: lazy(() => import('../components/OffboardingPage')),
  storeDependencies: [
    { store: EmploymentsStore },
    { store: ChangeReasonsStore },
  ],
  menuItemConfig: new MenuItemConfig({
    icon: lazy(() => import('@mui/icons-material/WorkHistory')),
    label: `${OFFBOARDING_PAGE_LOCALE_PATH}.pageConfig.label`,
    group: HR_MENU_GROUP,
    isCollapsibleGroup: true,
  }),
};

